import { Injectable } from "@angular/core";
import { HttpService } from "../http.service";

@Injectable({
  providedIn: "root",
})
export class LoginIslemleriService {
  constructor(private http: HttpService) {}

  // Bulgu 3.1.12: Hassas bilgiler URL yerine istek gövdesi ile gönderilir.
  sifremiUnuttum(kullaniciAdi, telSon4Hane, captchaKey, captchaDeger) {
    return this.http.httpPost(`Auth/SifremiUnuttum`, {
      KullaniciAdi: kullaniciAdi,
      TelSonDortHane: telSon4Hane,
      CaptchaKey: captchaKey,
      CaptchaDeger: captchaDeger,
    });
  }
  smsKoduDogrulu(kullaniciAdi, smsKodu) {
    return this.http.httpPost(`Auth/SmsKoduDogrula`, {
      KullaniciAdi: kullaniciAdi,
      SmsKodu: smsKodu,
    });
  }
  ilkGirisSifreGuncelle(data) {
    return this.http.httpPut("LoginIslemleri/IlkGirisSifreGuncelle", data);
  }

  gunKontrolSifreGuncelle(data) {
    return this.http.httpPut("LoginIslemleri/GunKontrolSifreGuncelle", data);
  }

  smsKoduIleSifreGuncelle(data) {
    return this.http.httpPut("LoginIslemleri/SmsKoduIleSifreGuncelle", data);
  }
}
